import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getBookingCalendar(params) {
  return axios({ method: 'get', url: `${API_URL}/admin/booking_calendar`, params: params || {} });
}
